<div class="modal__content">
    <h2>{{ $t('modals.resetpassword.title') }}</h2>
    <form class="form" @submit.prevent="activeValidation = true; onSubmit();">
        <form-alerts ref="formAlert"></form-alerts>
        <div class="form__group">
            <label>{{ $t('modals.resetpassword.password') }}</label>
            <input :class="{alert: errors.password && activeValidation}" :disabled='isSubmitting' name="password" type="password" :placeholder="$t('modals.login.password-placeholder')" v-model="password" />
            <div class="form__group-alert" v-if="errors.email && activeValidation">{{ $t('modals.resetpassword.alerts.errorNoValidPassword') }}</div>
        </div>
        <div class="form__group">
            <label>{{ $t('modals.resetpassword.confirmPassword') }}</label>
            <input :class="{alert: errors.confirmPassword && activeValidation}" :disabled='isSubmitting' name="confirmPassword" type="password" :placeholder="$t('modals.login.password-placeholder')" v-model="confirmPassword" />
            <div class="form__group-alert" v-if="errors.confirmPassword && activeValidation">{{ $t('modals.resetpassword.alerts.errorNoValidPassword') }}</div>
        </div>
        <div class="form__group">
            <button class="btn btn-full" :disabled='isSubmitting' type="submit">{{ $t('modals.resetpassword.resetpassword') }}</button>
        </div>
    </form>
</div>
